import { loadScript } from '@/utils/helpers';

export function loadYotpoScript(): Promise<void> {
  if (!process.env.NEXT_PUBLIC_YOTPO_APP_KEY) {
    console.warn(`Missing Yotpo app key. Can't display product reviews.`);
    return Promise.resolve();
  }

  if (typeof window !== 'undefined' && window.yotpo) {
    window.yotpo.refreshWidgets();
    return Promise.resolve();
  } else {
    return new Promise((resolve) => {
      loadScript(
        `https://staticw2.yotpo.com/${process.env.NEXT_PUBLIC_YOTPO_APP_KEY}/widget.js`,
        'yotpo-script',
        () => {
          // Script loaded successfully
          resolve();
        },
      );
    });
  }
}

export function refreshYotpoWidgets() {
  if (
    typeof window !== 'undefined' &&
    window.yotpo &&
    typeof window.yotpo.refreshWidgets === 'function'
  ) {
    window.yotpo.refreshWidgets();
  }
}
